import { Calculate } from '@mui/icons-material';
import React, { useEffect, useRef, useState } from 'react';
import { container } from 'tsyringe';
import { ApiService } from '../../services/api-service';
import { getOffset, useSharedState } from '../../utils/helpers';
import useOnClickOutside from '../hooks/useOnClickOutside';

import './RegisterPopup.scss';



export interface RegisterPopupDialogProps {
  kind: number;
  position?: any;
  closeCallback: any;
}
export interface RegisterPopupProps {
  divId?: string
}

const RegisterPopup = (props: RegisterPopupProps) => {

  const [showPopup, setShowPopup] = useState(false);
  const [apiService] = useState(container.resolve(ApiService));
  const [registerPopupQueue] = useSharedState(apiService.registerPopupQueue$);


  const [position, setPosition] = useState(null);
  // const defaultPosition = { top: '50%', left: '50%' };

  useEffect(() => {
    setShowPopup(registerPopupQueue);
  }, [registerPopupQueue])

  const closePopup = () => {
    apiService.closeRegisterPopup();
    setShowPopup(false);
  }

  // useEffect(() => {
  //   if (props.divId && props.divId != '') {
  //     const div = document.getElementById(props.divId);
  //     if (div) {
  //       let boundRect = getOffset(div);
  //       console.log('Register popup parent=', boundRect);
  //       let top = (boundRect.top - div.offsetHeight - 256);
  //       let left = (boundRect.left + div.offsetWidth / 2 - 350);

  //       if (top < 78) top = 78;
  //       if (top > window.innerHeight - 256) top = window.innerHeight - 256;

  //       if (left < 0) left = 0;
  //       if (left > window.innerWidth - 350) left = window.innerWidth - 350;

  //       setPosition({
  //         top: top + 'px',
  //         left: left + 'px'
  //       })

  //     } else {
  //       setPosition(defaultPosition);
  //     }
  //   } else {
  //     setPosition(defaultPosition);
  //   }
  // }, [])

  return (
    <>
    { showPopup &&
      <RegisterPopupDialog kind={1} closeCallback={closePopup} position={position}></RegisterPopupDialog>
    }
    </>
  )
}


const RegisterPopupDialog = (props: RegisterPopupDialogProps) => {
  const closePopup = () => {
    if (props.closeCallback) {
      props.closeCallback();
    }
  }

  const popupRef = useRef(undefined);
  useOnClickOutside(popupRef, (event) => {
    closePopup();
  });



  const registerLinkUrl = "https://www.bluejeans.com/trial/free-virtual-event-webinar";
  const contactSalesLinkUrl = "https://store.bluejeans.com/?plan=events";

  return (
    <>
    { props.kind === 1 &&
      <div className='register-background'>
        <div className='register-popup' ref={popupRef}>
          <div className='body'>
            <div className='close' onClick={() => closePopup()}></div>
            <div className='title'>Interested in BlueJeans Studio?</div>
            <div className='text'>Buy now or sign up for a<br/>14-day free trial!</div>
            <div className='line'>
              <a className='studio-primary-btn sales-link' href={contactSalesLinkUrl} target='_blank' rel='noreferrer'>BUY NOW</a>
              <a className='studio-primary-btn btn1' href={registerLinkUrl} target='_blank' rel='noreferrer'>TRY FOR FREE</a>
            </div>
          </div>
        </div>
      </div>
    }
    </>
  )
}

export default RegisterPopup;